export const SUCCESS_MODAL = 'successChangeEmail'
